/* eslint-disable import/prefer-default-export */
export const useSlides = {
  width: 98,
  closeWidth: 56,
  padding: 13,
  closePadding: 12,
  menuList: [
    {
      defaultIcon: 'https://ydlunacommon-cdn.nosdn.127.net/44e0c17137df02cb303fe732d538e4a3.png',
      activeIcon: 'https://ydlunacommon-cdn.nosdn.127.net/c36b477d439047747d2a38bc86cfa889.png',
      title: '首页',
      path: '/home',
      activePath: ['/home'],
    },
    {
      defaultIcon: 'https://ydlunacommon-cdn.nosdn.127.net/b317049b73b3b40486cecd1cfb81a9a0.png',
      activeIcon: 'https://ydlunacommon-cdn.nosdn.127.net/59e2484b47434ae5a1f44a678caacd6b.png',
      title: '我的文档',
      path: '/personalspace',
      activePath: ['/personalspace'],
    },
  ],
}
